// Format an order-window date (ISO string) for compact display, e.g. "5 Jul".
export const formatWindowDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    if (isNaN(d)) return '';
    return d.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', timeZone: 'Africa/Johannesburg' });
  } catch {
    return '';
  }
};
